
























import VueOptions from '@utils/VueOptions'
import VenueNavbar from '@ui/VenueWizard/VenueNavbar'
import WizardNavigation from '@ui/VenueWizard/WizardNavigation'
import VenueDateBindSelector from '@ui/ResourceBindSelector/VenueDateBindSelector'
import Modal from '@components/Modal'

settings =
  name: 'VenueCalendarStep'

  vue:
    props: ['wizard', 'step']

    components: {
      VenueNavbar,
      WizardNavigation,
      VenueDateBindSelector,
      Modal,
    }

    data: ->
      missingDatesModal:
        show: false
        stepName: null

    computed:
      hasDates: ->
        @wizard.venueData.date_ids?.length > 0

      displayConfirmModal: ->
        !@hasDates

    methods:
      hiConfirmModal: (stepName) ->
        if !@hasDates
          @missingDatesModal.show = true
          @missingDatesModal.stepName = stepName
          return

export default VueOptions.vue settings
